import React from 'react';
import { IconBox, IconProps } from 'src/lib/IconBox';

// eslint-disable-next-line import/no-default-export,react/display-name
export default (props: IconProps) => (
  <IconBox viewBox="0 10 64 44" {...props}>
    <path d="M64.25 32.25L54.75 41.75L32.25 19.25L9.75 41.75L0.25 32.25L32.25 0.25L64.25 32.25Z" />
  </IconBox>
);
